<template>
    <div class="d-flex flex-column justify-start align-start">

        <v-row class="w-100 text-start">
            <v-col cols="12" class="position-absolute">
                <v-img
                :src="readersSoundImageURL"
                max-height="40px"
                max-width="40px"
                :min-width="$vuetify.breakpoint.xs ? '32' : '40'"
                :min-height="$vuetify.breakpoint.xs ? '32' : '40'"
                contain
                class="cursor-pointer voice-assistant"
                @click="read"
                :class="{'d-none': !audio}"
                ></v-img>
            </v-col>
            <v-col cols="12">
                <p class="diagnostic-title mb-0">{{ data.name }}</p>
            </v-col>
        </v-row>
        <div class="diagnostic-text text-justify font-weigth-regular pr-5">
            <p class="text-justify diagnostic-text-body" v-html="data.content.contenido"></p>
        </div>
        <div class="row w-100 align-items-center justify-content-center">
            <div class="col">
                <v-btn
                color="#7764CA"
                outlined
                class="text-transform-none font-weight-bold border-radius-1"
                @click.stop="questionsMobile"
                >
                    {{ $t('initialTour.questions2') }}
                </v-btn> 
            </div>
        </div>
    </div>
</template>
<script>
import SpeechSynthesis from "@/mixins/SpeechSynthesis";

export default {
    data: () => ({
        audio: null,
        isNarratorActive: false,
        soundpauseicon: require('@/assets/img/icons/icon-voice-assistant-select.svg'),
        soundplayicon: require('@/assets/img/icons/icon-voice-assistant.svg'),
    }),
    computed: { 
        readersSoundImageURL() {
            return this.isNarratorActive ? this.soundpauseicon : this.soundplayicon
        }
    },
    props: {
        data: { type: Object, default: null },
    },
    methods: {
        questionsMobile(){
            this.$emit('toogleQuestionsMobile')
        }, 
        read(){
            if (this.audio) {
                this.play();
            } else {
                const el = this.createElementFromHTML(this.data.content.contenido);
                this.readText(el.innerText)
            }
        },
        createElementFromHTML(htmlString) {
            const div = document.createElement('div');
            div.innerHTML = htmlString.trim();
            return div;
        },
        loadAudio() {
            if (!this.data.id) {
                return;
            }
            const loadedAudio = new Audio(`${process.env.VUE_APP_VOICE_SAMPLE_URL}diagnostics/${this.data.id}.mp3`);
            loadedAudio.oncanplaythrough = () => {
                this.audio = loadedAudio;
            };
        },
        play() {
            if (this.audio && this.audio.paused) {
                this.audio.play()
                this.isNarratorActive = true
            } else {
                this.audio.pause()
                this.isNarratorActive = false
            }
        }
    },
    mounted() {
        this.loadAudio();
    },
    // watch para cuando cambia el id del diagnostico y parar el audio
    watch: {
        'data.id': function (newVal, oldVal) {
            if (newVal !== oldVal) {
                if (this.audio){
                    this.audio.pause();
                    this.audio = null;
                    this.isNarratorActive = false
                } 
                this.loadAudio();
            }
        }
    },
    // parar el audio cuando se destruye el componente
    beforeDestroy() {
        if (this.audio) this.audio.pause();
    },
    mixins: [SpeechSynthesis]
}
</script>

<style lang="scss">

.voice-assistant{
    position: absolute !important;
    top: 10px;
    left: 15px;
}

.diagnostic{
    &-title{
        font-size: 1.5rem;
        font-weight: 600;
        padding-left: 60px;
    }
    &-text {
        width: 100%;
        overflow: auto;
        &-body{
            font-size: 1.1rem;
            font-weight: 400;
        }
    }
    &-text-body img{
        max-width: 400px;
        display: block;
        margin: auto;
        padding: 30px;
    }
}
.diagnostic-text::-webkit-scrollbar-track{
    background-color: #EEECF8;
}
.diagnostic-text::-webkit-scrollbar-thumb {
    background-color: #7764CA;
}
</style>
